<template>
    <div>
        <el-dialog
            :visible.sync="showModal"
            width="800px"
            append-to-body
            :close-on-click-modal="false"
            @closed="resetForm"
            :destroy-on-close="true"
        >
            <template slot="title">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag class="rounded-circle"><i class="el-icon-office-building"></i></el-tag>
                    Novo prazo de pagamento
                </div>
            </template>

            <el-form 
                :model="payload" 
                ref="prazoPagamentoStoreForm"
                label-position="top" 
                status-icon
            > 
                <el-row :gutter="12">
                    <!-- Codigo -->
                    <el-col :span="6">
                        <el-form-item
                            prop="codigo_protheus"
                            :rules="[
                                { required: true, message: 'Código do protheus é obrigatório' },
                                { validator: validateMin(2, 'Código deve possuir no mínimo 2 caracteres'), trigger: 'blur' },
                                { validator: validateMax(10, 'Código deve possuir no máximo 10 caracteres'), trigger: 'blur' },
                            ]"
                        >
                            <label>Código Protheus</label>

                            <el-input
                                v-model="payload.codigo_protheus"
                                placeholder="Ex: 2"
                                v-mask="['##########']"
                                :maxlength="10"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <!-- Descricao -->
                    <el-col :span="18">
                        <el-form-item 
                            prop="descricao"
                            :rules="[
                                { required: true, message: 'A descrição é obrigatória' },
                            ]"
                        >
                            <label>Descrição</label>
                            <el-input
                                v-model="payload.descricao" 
                                placeholder="Ex: Matriz"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Actions -->
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item>
                                <el-button 
                                    plain
                                    :disabled="isLoading"
                                    @click="() => {
                                        toggleModal();
                                        resetForm();
                                    }"
                                >
                                    Cancelar
                                </el-button>

                                <el-button 
                                    type="primary"
                                    plain
                                    :disabled="isLoading"
                                    @click="onSubmit"
                                >
                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                    <i class="fas fa-check-circle"></i>
                                    Salvar
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Form, 
        FormItem,
        Tag,
        Dialog,
    } from "element-ui";

    //Api
    import { PrazoPagamentoApi } from "@/api/PrazoPagamentoApi";
    import { GeneralResourcesApi } from "@/api/GeneralResourcesApi";

    const generalResourcesApi = new GeneralResourcesApi();
    const prazoPagamentoApi = new PrazoPagamentoApi();

    // Utils
    import { validateMin, validateMax } from "@/schemas/generalSchema"

    export default {
        name: 'prazo-pagamento-create-modal',
        data() {
            return {
                payload: {
                    codigo_protheus: null,
                    descricao: null,
                },
                showModal: false,
                isLoading: false,
            }
        }, 
        methods: {
            onSubmit() {
                this.$refs.prazoPagamentoStoreForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;
                    
                    try {
                        const res = await prazoPagamentoApi.store(this.payload)

                        Notification.success({
                            title: 'Sucesso',
                            message: res?.data?.msg ?? 'Prazo de pagamento criado com sucesso!'
                        });
                    } catch (error) {
                        if (error?.response?.status == 422) {
                            if (error?.response?.data.errors) {
                                Object.values(error.response.data.errors)
                                .flat()
                                .forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }
                            
                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível criar o prazo de pagamento!'
                        });
                    } finally {
                        this.isLoading = false;
                        this.toggleModal();
                        this.resetForm();
                        this.$emit('created');
                    }
                })
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetForm() {
                if (this.$refs.prazoPagamentoStoreForm) {
                    this.$refs.prazoPagamentoStoreForm.resetFields();
                }
            },
            validateMin,
            validateMax,
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Dialog.name]: Dialog,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/prazo_pagamento/PrazoPagamentoCreateModal.vue